import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const ApprovalTitleTextInput = ({
  approvalTitle,
  onChangeApprovalTitle
}) => /*#__PURE__*/_jsx(FormControl, {
  label: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "productApprovals.approvalTitle.label"
  }),
  help: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "productApprovals.approvalTitle.help"
  }),
  required: true,
  validationMessage: !approvalTitle.trim() ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "productApprovals.approvalTitle.error.noApprovalTitle"
  }) : undefined,
  error: !approvalTitle.trim(),
  children: /*#__PURE__*/_jsx(TextInput, {
    type: "text",
    value: approvalTitle,
    onChange: ({
      target: {
        value
      }
    }) => onChangeApprovalTitle(value)
  })
});